import pdfMake from 'pdfmake/build/pdfmake.js';
import htmlToPdfmake from "html-to-pdfmake";
import moment from 'moment';
import 'moment-timezone';

const InformedConsentNoRefundPDF = async (data) => {

    pdfMake.fonts = {
        OpenSans: {
            normal: 'OpenSans-Regular.ttf',
            bold: 'OpenSans-Bold.ttf',
            italics: 'OpenSans-Italic.ttf',
            bolditalics: 'OpenSans-ExtraBoldItalic.ttf'
        },
        Merriweather: {
            normal: 'Merriweather-Regular.ttf',
            bold: 'Merriweather-Bold.ttf',
            italics: 'Merriweather-Italic.ttf',
            bolditalics: 'Merriweather-ExtraBoldItalic.ttf'
        },
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Bold.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-BoldItalic.ttf'
        }
    };

    let body = [];

    const fecha = moment().tz("America/Bogota").format("DD/MM/YYYY");
    const name = data.paciente.nombre_paciente;

    //Firma del Doctor
    let urlFirmaDoctor = "";
    if (data.firma_doctor != null && data.firma_doctor != undefined) {
        let urlServeDoctor = data.firma_doctor;
        let testDoctor = fetch(urlServeDoctor)
            .then(response => {
                if (response.status === 500) {
                    return false;
                } else {
                    return true;
                }
            });

        let isImgDoctor = await testDoctor;
        if (isImgDoctor) {
            urlFirmaDoctor = urlServeDoctor;
        } else {
            urlFirmaDoctor = 'https://i.postimg.cc/0jznYVsr/prueba.png';
        }
    }
    else {
        urlFirmaDoctor = 'https://i.postimg.cc/0jznYVsr/prueba.png';
    }

    //Firma del Doctor
    let urlFirmaTecnologo = "";
    if (data.firma_tecnologo != null && data.firma_tecnologo != undefined) {
        //Firma del Tecnologo
        let urlServeTecnologo = data.firma_tecnologo;
        let testTecnologo = fetch(urlServeTecnologo)
            .then(response => {
                if (response.status === 500) {
                    return false;
                } else {
                    return true;
                }
            });

        let isImgTecnologo = await testTecnologo;
        if (isImgTecnologo) {
            urlFirmaTecnologo = urlServeTecnologo;
        } else {
            urlFirmaTecnologo = 'https://i.postimg.cc/0jznYVsr/prueba.png';
        }
    }
    else {
        urlFirmaTecnologo = 'https://i.postimg.cc/0jznYVsr/prueba.png';
    }



    //Firma del Paciente
    let urlFirmaPaciente = "";
    if (data.firma_paciente != null && data.firma_paciente != undefined) {
        let urlServePaciente = data.firma_paciente;

        let testPaciente = fetch(urlServePaciente)
            .then(response => {
                if (response.status === 500) {
                    return false;
                } else {
                    return true;
                }
            });

        let isImgPaciente = await testPaciente;
        if (isImgPaciente) {
            urlFirmaPaciente = urlServePaciente;
        } else {
            urlFirmaPaciente = 'https://i.postimg.cc/0jznYVsr/prueba.png';
        }
    }
    else {
        urlFirmaPaciente = 'https://i.postimg.cc/0jznYVsr/prueba.png';
    }


    //Firma del Primer Testigo
    let urlFirmaPrimerTestigo = "";
    if (data.firma_primer_testigo != null && data.firma_primer_testigo != undefined) {
        let urlServePrimerTestigo = data.firma_primer_testigo;
        let testPrimerTestigo = fetch(urlServePrimerTestigo)
            .then(response => {
                if (response.status === 500) {
                    return false;
                } else {
                    return true;
                }
            });

        let isImgPrimerTestigo = await testPrimerTestigo;
        if (isImgPrimerTestigo) {
            urlFirmaPrimerTestigo = urlServePrimerTestigo;
        } else {
            urlFirmaPrimerTestigo = 'https://i.postimg.cc/0jznYVsr/prueba.png';
        }
    }
    else {
        urlFirmaPrimerTestigo = 'https://i.postimg.cc/0jznYVsr/prueba.png';
    }

    //Firma del Segundo Testigo
    let urlFirmaSegundoTestigo = "";
    if (data.firma_segundo_testigo != null && data.firma_segundo_testigo != undefined) {
        let urlServeSegundoTestigo = data.firma_segundo_testigo;
        let testSegundoTestigo = fetch(urlServeSegundoTestigo)
            .then(response => {
                if (response.status === 500) {
                    return false;
                } else {
                    return true;
                }
            });

        let isImgSegundoTestigo = await testSegundoTestigo;
        if (isImgSegundoTestigo) {
            urlFirmaSegundoTestigo = urlServeSegundoTestigo;
        } else {
            urlFirmaSegundoTestigo = 'https://i.postimg.cc/0jznYVsr/prueba.png';
        }
    }
    else {
        urlFirmaSegundoTestigo = 'https://i.postimg.cc/0jznYVsr/prueba.png';
    }

    let htmlInformedConsent = null;
    if (data.hasOwnProperty("consentimiento")) {
        htmlInformedConsent = htmlToPdfmake(data.consentimiento);
    } else {
        htmlInformedConsent = null;
    }


    const imageLogo = async () => {
        return {
            rowSpan: 5,
            image: await getBase64ImageFromURL(sessionStorage.getItem('logoURL')),
            fit: [150, 60],
            alignment: 'center'
        }
    };

    let logoIPS = await imageLogo();

    const documentDefinition = {
        pageSize: 'LETTER',
        pageMargins: [30, 100, 40, 60],
        pageOrientation: 'portrait',
        header: function (currentPage, pageCount) {
            return {
                columns: [
                    {
                        margin: [40, 20, 25, 0],
                        table: {
                            widths: ['*', 270, 60, 70],
                            headerRows: 1,
                            body: [
                                [
                                    logoIPS,
                                    { rowSpan: 5, text: 'FORMATO DE NO REEMBOLSO', style: 'headConsent' },
                                    { text: 'CODIGO', style: 'headConsent' }, { text: 'FT-IM-40', style: 'headConsent' }
                                ],
                                ['', '', { text: 'CREACIÓN', style: 'headConsent' }, { text: '24/08/2016', style: 'headConsent' }],
                                ['', '', { text: 'VERSIÓN', style: 'headConsent' }, { text: '2', style: 'headConsent' }],
                                ['', '', { text: 'PAGINA', rowSpan: 2, style: 'headConsent' }, { text: currentPage.toString() + ' DE ' + pageCount.toString(), rowSpan: 2, style: 'headConsent' }],
                                ['', '', '', ''],
                            ]
                        },
                    }
                ]
            }
        },
        defaultStyle: {
            fontSize: 8,
            alignment: 'left'
        },
        info: {
            author: "Esteban Londoño",
        },
        footer: function (currentPage, pageCount) {
            return {
                table: {
                    widths: ['*', '*', '*'],
                    body: [
                        [{ text: "Página " + currentPage.toString() + ' de ' + pageCount, style: 'head' }, { text: name, style: 'foter' }, { text: 'Fecha Impresión: ' + fecha, style: 'head' }],
                    ]
                },
                layout: 'noBorders',
                margin: [20, 0, 0, 5],
            };
        },
        content: [
            htmlInformedConsent,
            {
                columns: [
                    {
                        // auto-sized columns have their widths based on their content                                       
                        margin: [40, 20, 25, 0],
                        layout: 'headerLineOnly',
                        table: {
                            widths: [120],
                            headerRows: 1,
                            body: [
                                data.firma_doctor != null ? [{
                                    image: await getBase64ImageFromURL(urlFirmaPaciente),
                                    fit: urlFirmaPaciente == 'https://i.postimg.cc/0jznYVsr/prueba.png' ? [35, 35] : [80, 80],
                                }] : [''],
                                [{ text: 'Firma del Paciente', style: 'textStyle', }],

                            ]
                        },
                    }
                ],
                columnGap: 20
            }
        ],
        styles: {
            headConsent: {
                fontSize: 11,
                bold: true,
                alignment: 'center'
            },
            head: {
                fontSize: 7,
                bold: true,
                alignment: 'left'
            },
            tableheader: {
                fontSize: 11,
                bold: true,

            },
            textStyle: {
                fontSize: 9,
            },
            tableTexStyle: {
                fontSize: 8,
                alignment: 'left'
            },
            foter: {
                alignment: 'center',
                fontSize: 6,
            },
            medicStyle: {
                margin: [0, 5, 0, 0],
                fontSize: 10,
                alignment: 'left',
            },
            'html-p': {
                fontSize: 12
            }
        }
    };

    //pdfMake.createPdf(documentDefinition).open();
    const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
    pdfDocGenerator.getDataUrl(function (outDoc) {
        document.getElementById('pdfV').src = outDoc;
    });

    function getBase64ImageFromURL(url) {
        return new Promise((resolve, reject) => {
            var img = new Image();
            img.setAttribute("crossOrigin", "anonymous");
            img.onload = () => {
                var canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;

                var ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);

                var dataURL = canvas.toDataURL("image/png");

                resolve(dataURL);
            };
            img.onerror = error => {
                reject(error);
            };
            img.src = url;
        });
    }

}

export default InformedConsentNoRefundPDF;